import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-about">
          <h3>Jaat College of Education</h3>
          <p>
            Empowering future educators since 2007. Affiliated to Kurukshetra University 
            and approved by NCTE. Working under the administration of Mahavir Shiksha Samiti, Karnal.
          </p>
        </div>
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#activities">Activities</a></li>
            <li><a href="#affiliations">Affiliations</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>
        <div className="footer-quick">
          <h4>Resources</h4>
          <ul>
            <li><a href="/ncte-affiliation.pdf" target="_blank" rel="noopener noreferrer">NCTE Affiliation</a></li>
            <li><a href="/college-brochure.pdf" target="_blank" rel="noopener noreferrer">College Brochure</a></li>
            <li><a href="https://www.jcekarnal.in/" target="_blank" rel="noopener noreferrer">Official Website</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Jaat College of Education, Karnal. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
